import PropTypes from 'prop-types';
import { withRouter } from 'react-router-dom';
import { Typography } from '@material-ui/core';
import { withStyles } from '@material-ui/core/styles';
import React, { Component } from 'react';
import { UserConsumer } from '../../core/providers/UserProvider';
import { globalStyles as styles } from '../style/gstheme';
import AddSubscriptionContainer from './AddSubscriptionContainer';
import InviteHandler from './InviteHandler';
import SubscriptionCardContainer from './SubscriptionCardContainer';
import { MAX_SUBSCRIPTIONS, MANAGED_MODE } from '../../core/utils/constants';

class SubscriptionManager extends Component {

  render() {

    const { classes, onNewSubscription } = this.props;

    return (
      <UserConsumer>
        {({ user, subscriptions, setSubscription, cancelSubscription, activeSubscription, cancelledSubscriptions }) => {
          const displayManagement = subscriptions && subscriptions.length > 0 ? !subscriptions.some(subItem => !subItem.approved) : true;
          if (user.systemAdmin || user.superAdmin) {
            return <Typography variant="body2">Adminstrators cannot have subscriptions.</Typography>;
          }
          else return <div style={{ marginTop: 20, paddingRight: 30 }}>
            {displayManagement && subscriptions && window.Graphologi.mode !== MANAGED_MODE &&
              <div style={{ height: 40, overflow: 'auto' }}>
                {subscriptions.length < MAX_SUBSCRIPTIONS &&
                  <div style={{ float: 'right', paddingRight: 40 }}>
                    <AddSubscriptionContainer
                      permitTrial={!user.hasHadTrial}
                      onNewSubscription={onNewSubscription}
                      subscriptions={subscriptions}
                      setSubscription={setSubscription} />
                  </div>
                }
              </div>
            }
            {subscriptions && subscriptions.length > 0 &&
              <div style={{ overflow: 'auto' }}>
                <Typography variant="h2" className={classes.subMainHeading}>Owned</Typography>
                {
                  subscriptions.sort(function (a, b) {
                    return a.subscriptionName < b.subscriptionName ? -1 : 1;
                  }).map(subscription =>
                    <SubscriptionCardContainer
                      onCancel={cancelSubscription}
                      cancelled={cancelledSubscriptions.includes(subscription.id)}
                      subscriptionType={subscription.subscriptionType}
                      approved={subscription.approved}
                      expirationDate={subscription.expirationDate}
                      subscriptionIRI={subscription.id}
                      cancelURL={subscription.cancelURL}
                      updateURL={subscription.updateURL}
                      key={subscription.id}
                      name={subscription.subscriptionName}
                      subscriptionPackage={subscription.subscriptionPackage}
                      maxUsers={subscription.maxUsers}
                      active={subscription.id === activeSubscription}
                      selectSubscription={setSubscription}
                    />
                  )
                }
              </div>
            }
            <div style={{ clear: 'both', marginBottom: 40, overflow: 'auto' }}>
              <InviteHandler />
            </div>
          </div>;
        }}
      </UserConsumer>
    );
  }
}

SubscriptionManager.propTypes = {
  classes: PropTypes.object,
  onNewSubscription: PropTypes.func.isRequired
};

export default withRouter(withStyles(styles)(SubscriptionManager));